import type { SearchGeoTargetConstantsResponse } from "@rails_api_base";

type GeoTarget = NonNullable<SearchGeoTargetConstantsResponse>[number];

// The country target we seed by default and auto-drop once more specific
// locations are picked. Mirrors the backend (Account::COUNTRIES /
// Account#default_geo_target_constant) so the frontend default matches the
// account's market. `id` is cosmetic here (the seed flow rebuilds the target
// without it), so it tracks criteria_id.
const DEFAULT_LOCATION_TARGETS = {
  USA: {
    id: 2840,
    criteria_id: 2840,
    name: "United States",
    canonical_name: "United States",
    country_code: "US",
    target_type: "Country",
    status: "Active",
  },
  Canada: {
    id: 2124,
    criteria_id: 2124,
    name: "Canada",
    canonical_name: "Canada",
    country_code: "CA",
    target_type: "Country",
    status: "Active",
  },
} satisfies Record<string, GeoTarget>;

export type DefaultCountry = keyof typeof DEFAULT_LOCATION_TARGETS;

export const DEFAULT_CRITERIA_IDS: Record<DefaultCountry, number> = {
  USA: DEFAULT_LOCATION_TARGETS.USA.criteria_id,
  Canada: DEFAULT_LOCATION_TARGETS.Canada.criteria_id,
};

export function defaultLocationTarget(country: string | undefined | null): GeoTarget {
  if (country && country in DEFAULT_LOCATION_TARGETS) {
    return DEFAULT_LOCATION_TARGETS[country as DefaultCountry];
  }
  return DEFAULT_LOCATION_TARGETS.USA;
}

export function defaultCriteriaId(country: string | undefined | null): number {
  return defaultLocationTarget(country).criteria_id;
}
